import { AxiosResponse } from 'axios';
import { Notice } from '../../Model/Notice';
import {
  CreateNoticeDTO,
  NoticeRepository,
} from '../../Domain/Repositories/NoticeRepository';
import { api } from '../../../../api/axiosInstance';

function normalizeList<T>(data: T[] | { results?: T[] }): T[] {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export class NoticeRepositoryImpl implements NoticeRepository {
  private http = api;

  create(dto: CreateNoticeDTO): Promise<Notice> {
    return this.http
      .post<Notice>('/notices/', dto)
      .then((r: AxiosResponse<Notice>) => r.data);
  }

  list(): Promise<Notice[]> {
    return this.http
      .get<Notice[] | { results?: Notice[] }>('/notices/')
      .then((r: AxiosResponse<Notice[] | { results?: Notice[] }>) =>
        normalizeList(r.data),
      );
  }

  get(id: number): Promise<Notice> {
    return this.http
      .get<Notice>(`/notices/${id}/`)
      .then((r: AxiosResponse<Notice>) => r.data);
  }

  update(id: number, dto: Partial<CreateNoticeDTO>): Promise<Notice> {
    return this.http
      .put<Notice>(`/notices/${id}/`, dto)
      .then((r: AxiosResponse<Notice>) => r.data);
  }

  delete(id: number): Promise<void> {
    return this.http
      .delete(`/notices/${id}/`)
      .then(() => undefined);
  }
}
